export const SpeechSynthesysIcon = () => (
  <svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.285 0C7.47839 0 6.8245 0.586063 6.8245 1.30901V12.7764C6.8245 13.114 6.51917 13.3876 6.14252 13.3876C5.76588 13.3876 5.46055 13.114 5.46055 12.7764V6.67466H5.46236V5.23057C5.46236 4.50763 4.80847 3.92157 4.00185 3.92157C3.19524 3.92157 2.54135 4.50763 2.54135 5.23057V6.66593H0.387933C0.173683 6.66593 0 6.8216 0 7.01363C0 7.20565 0.173683 7.36132 0.387933 7.36132H3.06133C3.20465 7.36132 3.32084 7.25718 3.32084 7.12873V6.66593H3.31988V5.23057C3.31988 4.893 3.62521 4.61934 4.00185 4.61934C4.3785 4.61934 4.68383 4.893 4.68383 5.23057V6.12056H4.68202V12.7764C4.68202 13.4993 5.33591 14.0854 6.14252 14.0854C6.94914 14.0854 7.60303 13.4993 7.60303 12.7764V1.30901C7.60303 0.971432 7.90836 0.697773 8.285 0.697773C8.66164 0.697773 8.96697 0.971431 8.96697 1.30901L8.96653 9.43066C8.96653 10.1536 9.62042 10.7397 10.427 10.7397C11.2336 10.7397 11.8875 10.1536 11.8875 9.43066L11.8876 2.82718C11.8876 2.4896 12.1929 2.21595 12.5696 2.21595C12.9462 2.21595 13.2515 2.4896 13.2515 2.82718V7.25023H13.2497V14.691C13.2497 15.4139 13.9036 16 14.7102 16C15.5169 16 16.1707 15.4139 16.1707 14.691L16.1708 1.5555C16.1708 1.21793 16.4761 0.944267 16.8527 0.944267C17.2294 0.944267 17.5347 1.21792 17.5347 1.5555V8.99626H17.5358V10.8768C17.5358 11.5997 18.1897 12.1858 18.9963 12.1858C19.8029 12.1858 20.4568 11.5997 20.4568 10.8768V7.49961H22.613C22.8267 7.49961 23 7.34433 23 7.15278C23 6.96122 22.8267 6.80594 22.613 6.80594H19.9373C19.794 6.80594 19.6778 6.91008 19.6778 7.03853L19.6783 10.8768C19.6783 11.2144 19.373 11.488 18.9963 11.488C18.6197 11.488 18.3144 11.2144 18.3144 10.8768V7.11241H18.3132V1.5555C18.3132 0.832556 17.6593 0.246494 16.8527 0.246494C16.0461 0.246494 15.3922 0.832557 15.3922 1.5555L15.3922 14.691C15.3922 15.0286 15.0869 15.3022 14.7102 15.3022C14.3336 15.3022 14.0283 15.0286 14.0283 14.691V8.93637H14.0301V2.82718C14.0301 2.10423 13.3762 1.51817 12.5696 1.51817C11.763 1.51817 11.1091 2.10423 11.1091 2.82718L11.109 9.43066C11.109 9.76824 10.8037 10.0419 10.427 10.0419C10.0504 10.0419 9.74506 9.76824 9.74506 9.43066L9.7455 1.30901C9.7455 0.586062 9.09161 0 8.285 0Z"
      fill="url(#paint0_linear_632_11541)"
      className="active-fill"
    />
    <defs>
      <linearGradient
        id="paint0_linear_632_11541"
        x1="4.95385"
        y1="2.09231"
        x2="13.1386"
        y2="17.2194"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0063B4" />
        <stop offset="1" stopColor="#009AF7" />
      </linearGradient>
    </defs>
  </svg>
);

export const SpeechStylesSupportIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM6.75 14.14C6.75 14.55 6.41 14.89 6 14.89C5.59 14.89 5.25 14.55 5.25 14.14V9.86C5.25 9.45 5.59 9.11 6 9.11C6.41 9.11 6.75 9.45 6.75 9.86V14.14ZM9.75 15.57C9.75 15.98 9.41 16.32 9 16.32C8.59 16.32 8.25 15.98 8.25 15.57V8.43C8.25 8.02 8.59 7.68 9 7.68C9.41 7.68 9.75 8.02 9.75 8.43V15.57ZM12.75 17C12.75 17.41 12.41 17.75 12 17.75C11.59 17.75 11.25 17.41 11.25 17V7C11.25 6.59 11.59 6.25 12 6.25C12.41 6.25 12.75 6.59 12.75 7V17ZM15.75 15.57C15.75 15.98 15.41 16.32 15 16.32C14.59 16.32 14.25 15.98 14.25 15.57V8.43C14.25 8.02 14.59 7.68 15 7.68C15.41 7.68 15.75 8.02 15.75 8.43V15.57ZM18.75 14.14C18.75 14.55 18.41 14.89 18 14.89C17.59 14.89 17.25 14.55 17.25 14.14V9.86C17.25 9.45 17.59 9.11 18 9.11C18.41 9.11 18.75 9.45 18.75 9.86V14.14Z"
      fill="#EC8813"
    />
  </svg>
);

export const SpeechMultilingualIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 17.47C15.29 17.47 13.69 16.73 12.41 15.36C10.96 16.67 9.07 17.47 7 17.47C6.59 17.47 6.25 17.13 6.25 16.72C6.25 16.31 6.59 15.97 7 15.97C10.47 15.97 13.34 13.22 13.71 9.7H12H7.01C6.6 9.7 6.26 9.36 6.26 8.95C6.26 8.54 6.6 8.21 7.01 8.21H11.25V7.28C11.25 6.87 11.59 6.53 12 6.53C12.41 6.53 12.75 6.87 12.75 7.28V8.21H14.44C14.46 8.21 14.48 8.2 14.5 8.2C14.52 8.2 14.54 8.21 14.56 8.21H16.99C17.4 8.21 17.74 8.55 17.74 8.96C17.74 9.37 17.4 9.71 16.99 9.71H15.21C15.06 11.42 14.42 12.99 13.44 14.27C14.44 15.38 15.69 15.98 17 15.98C17.41 15.98 17.75 16.32 17.75 16.73C17.75 17.14 17.41 17.47 17 17.47Z"
      fill="#199744"
    />
  </svg>
);

export const SpeechToSpeechIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 8.25V15.75"
      stroke="#009AF7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="active-stroke"
    />
    <path
      d="M7.5 5.75V18.25"
      stroke="#009AF7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="active-stroke"
    />
    <path
      d="M12 3.25V20.75"
      stroke="#009AF7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="active-stroke"
    />
    <path
      d="M16.5 5.75V18.25"
      stroke="#009AF7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="active-stroke"
    />
    <path
      d="M21 8.25V15.75"
      stroke="#009AF7"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="active-stroke"
    />
  </svg>
);
export const Speech2SpeechMicIcon = () => (
  <svg width="85" height="84" viewBox="0 0 85 84" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="85" height="84" rx="42" fill="#D9D9D9" />
    <g clipPath="url(#clip0_704_9256)">
      <path
        d="M54.5 39.5C54.5 46.4 48.9 52 42 52C35.1 52 29.5 46.4 29.5 39.5H24.5C24.5 48.325 31.025 55.575 39.5 56.8V64.5H44.5V56.8C52.975 55.575 59.5 48.325 59.5 39.5H54.5Z"
        fill="#0063B4"
      />
      <path
        d="M42 47C46.15 47 49.5 43.65 49.5 39.5V24.5C49.5 20.35 46.15 17 42 17C37.85 17 34.5 20.35 34.5 24.5V39.5C34.5 43.65 37.85 47 42 47ZM39.5 24.5C39.5 23.125 40.625 22 42 22C43.375 22 44.5 23.125 44.5 24.5V39.5C44.5 40.875 43.375 42 42 42C40.625 42 39.5 40.875 39.5 39.5V24.5Z"
        fill="#0063B4"
      />
      <path
        d="M42 47C46.15 47 49.5 43.65 49.5 39.5V24.5C49.5 20.35 46.15 17 42 17C37.85 17 34.5 20.35 34.5 24.5V39.5C34.5 43.65 37.85 47 42 47Z"
        fill="#0063B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_704_9256">
        <rect width="60" height="60" fill="white" transform="translate(12 12)" />
      </clipPath>
    </defs>
  </svg>
);

export const Speech2SpeechStopIcon = () => (
  <svg width="85" height="84" viewBox="0 0 85 84" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="85" height="84" rx="42" fill="#D9D9D9" />
    <g clipPath="url(#clip0_704_9252)">
      <rect x="22" y="22" width="40" height="40" rx="10" fill="#0063B4" />
    </g>
    <defs>
      <clipPath id="clip0_704_9252">
        <rect x="22" y="22" width="40" height="40" rx="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Speech2SpeechWaveIcon = () => (
  <svg width="67" height="32" viewBox="0 0 67 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="67" height="32" rx="16" fill="white" />
    <rect className="rect-1" x="16.75" y="11" width="8.375" height="10" rx="4.1875" fill="#0865A7" />
    <rect className="rect-2" x="29.3125" y="8" width="8.375" height="16" rx="4.1875" fill="#0865A7" />
    <rect className="rect-3" x="41.875" y="11" width="8.375" height="10" rx="4.1875" fill="#0865A7" />
  </svg>
);

export const SpeechTranslationPlayIcon = () => (
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.9577 2.83331C9.13768 2.83331 2.79102 9.17998 2.79102 17C2.79102 24.82 9.13768 31.1666 16.9577 31.1666C24.7777 31.1666 31.1243 24.82 31.1243 17C31.1243 9.17998 24.7918 2.83331 16.9577 2.83331ZM21.2077 20.1591L17.0993 22.525C16.5893 22.8225 16.0227 22.9641 15.4702 22.9641C14.9035 22.9641 14.351 22.8225 13.841 22.525C12.821 21.93 12.2118 20.8816 12.2118 19.6916V14.9458C12.2118 13.77 12.821 12.7075 13.841 12.1125C14.861 11.5175 16.0793 11.5175 17.1135 12.1125L21.2218 14.4783C22.2418 15.0733 22.851 16.1216 22.851 17.3116C22.851 18.5016 22.2418 19.5641 21.2077 20.1591Z"
      fill="#0063B4"
    />
  </svg>
);

export const SpeechTranslationDeleteIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.1757 20.0003C14.0849 20.0001 14.0123 20.0719 14.0165 20.1579L14.4227 28.509C14.4602 29.2819 15.1294 29.8882 15.9461 29.8896L23.6791 29.9027C24.4958 29.904 25.167 29.2999 25.2072 28.5272L25.6412 20.1775C25.6457 20.0916 25.5734 20.0195 25.4825 20.0194L14.1757 20.0003ZM21.864 21.2189C21.8644 20.9525 22.0927 20.737 22.374 20.7375C22.6553 20.738 22.8828 20.9542 22.8824 21.2206L22.8719 27.49C22.8715 27.7564 22.6432 27.9719 22.3619 27.9714C22.0806 27.9709 21.853 27.7547 21.8535 27.4883L21.864 21.2189ZM19.3179 21.2146C19.3184 20.9482 19.5466 20.7327 19.8279 20.7332C20.1093 20.7337 20.3368 20.9499 20.3363 21.2163L20.3259 27.4857C20.3254 27.7521 20.0972 27.9676 19.8158 27.9671C19.5345 27.9666 19.307 27.7504 19.3074 27.484L19.3179 21.2146ZM16.7718 21.2103C16.7723 20.9439 17.0005 20.7284 17.2819 20.7289C17.5632 20.7294 17.7907 20.9456 17.7903 21.212L17.7798 27.4814C17.7793 27.7478 17.5511 27.9633 17.2698 27.9628C16.9884 27.9623 16.7609 27.7461 16.7614 27.4797L16.7718 21.2103Z"
      fill="#ff6c76"
    />
    <path
      d="M25.1301 16.678L22.2926 16.6732L22.2937 16.0088C22.2955 14.908 21.6041 14.0145 20.7493 14.0131L18.6857 14.0096C17.8309 14.0081 17.1365 14.8993 17.1347 16.0001L17.1335 16.6645L14.2961 16.6597C13.5838 16.6585 13.0051 17.4011 13.0035 18.3184L13.0013 19.6472C13.0007 20.0141 13.2312 20.3119 13.5161 20.3124L25.8978 20.3333C26.1828 20.3338 26.4142 20.0368 26.4149 19.6698L26.4171 18.3411C26.4186 17.4238 25.8424 16.6792 25.1301 16.678ZM18.1665 16.0018C18.1671 15.6356 18.3991 15.3379 18.6835 15.3383L20.7471 15.3418C21.0315 15.3423 21.2625 15.6408 21.2619 16.0071L21.2608 16.6714L18.1654 16.6662L18.1665 16.0018Z"
      fill="#ff6c76"
    />
  </svg>
);
